import { createSlice } from "@reduxjs/toolkit";
import { getUserDetails } from './thunk';

export const initialState = {
    userDetails: {},
    error: {},
};

const UserDetailsSlice = createSlice({
    name: 'UserDetails',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getUserDetails.fulfilled, (state, action) => {
            state.userDetails = action.payload;
        });
        builder.addCase(getUserDetails.rejected, (state, action) => {
            state.error = action.payload.error || null;
        });
    }
});

export default UserDetailsSlice.reducer;